module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/paperwalletemptyFgOrange.e2efa08cc500f1a5fd222a60f8ed81f9.svg";